import React from 'react'
import { Navigate, useLocation } from 'react-router'

import {
  AGENTS_URL,
  TREND_DETECTION_LEGACY_URL,
  TREND_DETECTION_URL,
} from 'features/trend-detection/paths'

export const LegacyIssueAgentRedirect: React.FC = () => {
  const location = useLocation()
  // Old layout collapsed the feed and agent center under /issue-agent. Map each
  // sub-tree onto its new home, falling through to the feed for the bare path.
  const newPath = location.pathname
    .replace(
      new RegExp(`/${TREND_DETECTION_LEGACY_URL}/benchmarking-agents(/|$)`),
      `/${AGENTS_URL}/benchmarking$1`,
    )
    .replace(
      new RegExp(`/${TREND_DETECTION_LEGACY_URL}/agents(/|$)`),
      `/${AGENTS_URL}$1`,
    )
    .replace(
      new RegExp(`/${TREND_DETECTION_LEGACY_URL}(/|$)`),
      `/${TREND_DETECTION_URL}$1`,
    )
  return <Navigate to={newPath + location.search + location.hash} replace />
}
